import type { Dayjs } from 'dayjs';

/**
 * Формат ввода/отображения DatePicker'а — совпадает с ru-RU выводом
 * `formatDate` (ДД.ММ.ГГГГ). Без явного `format` инпут принимает только
 * ISO «YYYY-MM-DD», и ручной ввод в привычном для пользователя виде
 * «15.06.2026» молча отклонялся.
 */
export const DATE_FORMAT = 'DD.MM.YYYY';
export const DATE_TIME_FORMAT = 'DD.MM.YYYY HH:mm';

export function datePickerFormat(includeTime = false): string {
  return includeTime ? DATE_TIME_FORMAT : DATE_FORMAT;
}

/**
 * Сериализация значения date-поля для API.
 *
 * Без времени — календарная дата «YYYY-MM-DD»: полный ISO переводил бы
 * локальную полночь в UTC и сдвигал дату на день назад (выбрал 10 июля —
 * сохранилось 9 июля). Со временем — полный ISO-timestamp.
 */
export function dateFieldValue(d: Dayjs | null, includeTime = false): string | null {
  if (!d) return null;
  return includeTime ? d.toISOString() : d.format('YYYY-MM-DD');
}
